import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
const getAppearanceStyles = (props) => {
    switch (props.$appearance) {
        case 'red':
            return css `
        background-color: ${themeGet('colors.red.500')};
      `;
        case 'yellow':
            return css `
        background-color: ${themeGet('colors.yellow.500')};
      `;
        case 'blue':
            return css `
        background-color: ${themeGet('colors.blue.500')};
      `;
        case 'gray':
            return css `
        background-color: ${themeGet('colors.gray.800')};
      `;
        default:
            return null;
    }
};
export const Container = styled.div `
  display: grid;
  grid-gap: 0;
  grid-template-columns: ${props => props.$progress};
  height: ${pxToRem(8)};
  overflow: hidden;
  border-radius: ${themeGet('borderRadius.sm')};
  background-color: ${themeGet('colors.gray.100')};
`;
export const Segment = styled.div `
  ${getAppearanceStyles};
`;
